import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.inner = this.element.querySelector(".carousel-inner")
    this.boundOnSlide = this.onSlide.bind(this)
    this.boundOnSlid = this.onSlid.bind(this)
    this.element.addEventListener("slide.bs.carousel", this.boundOnSlide)
    this.element.addEventListener("slid.bs.carousel", this.boundOnSlid)
  }

  disconnect() {
    this.element.removeEventListener("slide.bs.carousel", this.boundOnSlide)
    this.element.removeEventListener("slid.bs.carousel", this.boundOnSlid)
  }

  onSlide(event) {
    const target = this.measure(event.relatedTarget)
    this.inner.style.height = `${this.inner.offsetHeight}px`
    void this.inner.offsetHeight
    if (target) this.inner.style.height = `${target}px`
  }

  onSlid() {
    this.inner.style.height = ""
  }

  measure(item) {
    if (!item) return 0

    let height = item.offsetHeight
    if (!height) {
      item.style.display = "block"
      item.style.visibility = "hidden"
      height = item.offsetHeight
      item.style.display = ""
      item.style.visibility = ""
    }
    return height
  }
}
